import constants from 'helpers/constants'
import getQueryValue from 'helpers/getters/getQueryValue'
import getCookieValue from 'helpers/getCookieValue'
import isNotEmpty from 'helpers/getters/isNotEmpty'


/**
 * Returns abTests values override from cookie or query param
 */
const getAbOverrides = (): AbTests => {
  const cookieAbTests = getCookieValue(constants.cookieNames.abTests)
  const queryAbTests = getQueryValue('abTests', true) as object

  return (isNotEmpty(queryAbTests) && queryAbTests) || cookieAbTests || {}
}

export default getAbOverrides
